import React from "react";
import config from '../config.js'

import axios from 'axios'

import {withRouter} from 'react-router-dom'

import { MuiThemeProvider } from '@material-ui/core/styles'

import { Button, Grid, TextField } from '@material-ui/core/'

import SystemMessageSnackbar from './SystemMessageSnackbar'
import LoadingIcon from "./LoadingIcon";
import LoadingIconSmall from "./LoadingIconSmall";
import { getCookie } from "../Helpers/cookies";

class FamilyPlanSettings extends React.Component {
  constructor(props) {
    super(props)

    // console.log("FamilyPlanSettings.js: constructor() props.aid=[" + props.aid + "]")

    this.state = {
      device: props.device,
      aid: props.aid,

      systemMessage: {},

      isLoading: true,
      isPrimary: false,
      settings: {
        aid: "",
        secondary_users: [],
        pending_invites: []
      },

      isRemovingEmail1: false,
      isRemovingEmail2: false,
      isRemovingEmail3: false,
      isRemovingEmail4: false,

      addEmailValue: "",
      isAddingEmail: false,
      userSearchText: "",
      userSearchResults: [],
      isSearching: false,

      isSendingInvite: false,
      nonUserInviteText: "",

      isReSendingInvite1: false,
      isReSendingInvite2: false,
      isReSendingInvite3: false,
      isReSendingInvite4: false,

      isRemovingInvite1: false,
      isRemovingInvite2: false,
      isRemovingInvite3: false,
      isRemovingInvite4: false
    }
  }

  callingAjax = false

  apiCheckIsPrimary = _aid => {
    if (this.callingAjax) {
      return
    }

    this.callingAjax = true

    let data = JSON.stringify({
      aid: this.state.aid
    })

    axios
      .post(config.apiServer + '/api/v4/familyplan/isPrimary', data, {
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then(
        response => {
          this.callingAjax = false

          const json = response.data
          // console.log("FamilyPlan isPrimary response: [" + JSON.stringify(json) + "]");

          const isPrimary = json.is_primary
          // console.log("FamilyPlan isPrimary: [" + isPrimary + "]");
          this.setState({
            isPrimary: isPrimary
          })

          if (isPrimary) {
            this.apiGetSettings()
          } else {
            this.setState({
              isLoading: false
            })
          }
        },
        error => {
          this.callingAjax = false

          // console.log("FamilyPlan isPrimary error: [" + JSON.stringify(error) + "]");
          this.setState({
            isLoading: false,
            isPrimary: false
          })
        }
      )
  }

  apiGetSettings = _aid => {
    if (this.callingAjax) {
      return
    }

    this.callingAjax = true

    let data = JSON.stringify({
      aid: this.state.aid
    })

    axios
      .post(config.apiServer + '/api/v4/familyplan/getSettings', data, {
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then(
        response => {
          this.callingAjax = false

          let json = response.data
          // console.log("apiGetSettings: /getSettings response: [" + JSON.stringify(json) + "]");

          if (!json || json === "") {
            json = {
              aid: "",
              secondary_users: [],
              pending_invites: []
            }
            // console.log("apiGetSettings: /getSettings fallback value: [" + JSON.stringify(json) + "]");
          }

          this.setState({
            isLoading: false,
            settings: json
          })

        },
        error => {
          this.callingAjax = false

          // console.log("FamilyPlan getSettings error: [" + JSON.stringify(error) + "]");
          this.setState({
            isLoading: false,
            systemMessage: {
              message:
                'Unexpected error getting Family Plan Settings, try again later.',
              type: 'error',
              duration: 6000,
              timestamp: new Date().getTime()
            }
          })
        }
      )
  }

  onRemoveSecondaryClicked = (user, index) => {
    console.log("onRemoveSecondaryClicked: email=[" + user + "]")

    if (this.callingAjax) {
      return
    }

    this.callingAjax = true

    let data = JSON.stringify({
      aid: this.state.aid,
      secondary_aid: user.id
    })

    // Add a loading animation while the removal is happening
    if (index === 0) {
      this.setState({
        isRemovingEmail1: true
      })
    } else if (index === 1) {
      this.setState({
        isRemovingEmail2: true
      })
    } else if (index === 2) {
      this.setState({
        isRemovingEmail3: true
      })
    } else if (index === 3) {
      this.setState({
        isRemovingEmail4: true
      })
    }

    axios
      .post(config.apiServer + '/api/v4/familyplan/secondary/remove', data, {
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then(
        response => {
          this.callingAjax = false

          // Hide the loading animation
          this.setState({
            isRemovingEmail1: false,
            isRemovingEmail2: false,
            isRemovingEmail3: false,
            isRemovingEmail4: false
          })

          const status = response.status
          const json = response.data
          // console.log("onRemoveSecondaryClicked: /secondary/remove response: status=[" + status + "], json=[" + JSON.stringify(json) + "]");

          if (status === 200) {
            let settings = this.state.settings
            settings.secondary_users.splice(index, 1) // 2nd parameter means remove one item only

            this.setState({
              settings: settings,
              systemMessage: {
                message: "Successfully removed " + user.name + " from your Family Plan",
                type: 'success',
                duration: 6000,
                timestamp: new Date().getTime()
              }
            })
          } else {
            // TODO: Implement error scenario

          }
        },
        error => {
          this.callingAjax = false

          // Hide the loading animation
          this.setState({
            isRemovingEmail1: false,
            isRemovingEmail2: false,
            isRemovingEmail3: false,
            isRemovingEmail4: false
          })

          const json = error.response.data
          const err = json.err
          let dispMsg = 'Unexpected error removing this user from your Family Plan, try again later.'
          if (json.hasOwnProperty("display_msg")) {
            dispMsg = json.display_msg
          }

          // console.log("FamilyPlan secondary/remove error response: [" + JSON.stringify(json) + "]");
          // console.log("onRemoveSecondaryClicked: /secondary/remove err=[" + err + "], display_msg=[" + dispMsg + "]")
          this.setState({
            systemMessage: {
              message: dispMsg,
              type: 'error',
              duration: 9000,
              timestamp: new Date().getTime()
            }
          })
        }
      )
  }

  onAddEmailValueChanged = (event) => {
    let value = event.target.value
    // console.log("onAddEmailValueChanged: value=[" + value + "]")

    this.setState({
      addEmailValue: value
    })
  }

  onAddSecondaryClicked = (event, user) => {
    if (this.callingAjax) {
      return
    }

    this.callingAjax = true

    let data = JSON.stringify({
      aid: this.state.aid,
      secondary_aid: user.id
    })

    // Add a loading animation while the add is happening
    this.setState({
      addingUser: user.id
    })

    axios
      .post(config.apiServer + '/api/v4/familyplan/secondary/add', data, {
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then(
        response => {
          this.callingAjax = false

          // Hide the loading animation
          this.setState({
            addingUser: null
          })

          const status = response.status
          const json = response.data
          // console.log("onAddSecondaryClicked: /secondary/add response: status=[" + status + "], json=[" + JSON.stringify(json) + "]");

          if (status === 200) {
            let settings = this.state.settings
            settings.secondary_users.push(user)

            this.setState({
              settings: settings,
              addEmailValue: "",
              systemMessage: {
                message: "Successfully added " + user.name + " to your Family Plan",
                type: 'success',
                duration: 6000,
                timestamp: new Date().getTime()
              }
            })

            if (settings.secondary_users.length >= 4) {
              this.setState({
                userSearchResults: []
              })
            }
          } else {
            // TODO: Implement error scenario

          }
        },
        error => {
          this.callingAjax = false

          // Hide the loading animation
          this.setState({
            addingUser: null
          })

          const json = error.response.data
          const err = json.err
          let dispMsg = 'Unexpected error adding this user to your Family Plan, try again later.'
          if (json.hasOwnProperty("display_msg")) {
            dispMsg = json.display_msg
          }

          // console.log("FamilyPlan secondary/remove error response: [" + JSON.stringify(json) + "]");
          // console.log("onAddSecondaryClicked: /secondary/add err=[" + err + "], display_msg=[" + dispMsg + "]")
          this.setState({
            systemMessage: {
              message: dispMsg,
              type: 'error',
              duration: 9000,
              timestamp: new Date().getTime()
            }
          })
        }
      )
  }

  onReSendInviteClicked = (invite, index) => {
    console.log("onReSendInviteClicked: invite=[" + invite.to + "]")

    if (this.callingAjax) {
      return
    }

    this.callingAjax = true

    // Add a loading animation while the removal is happening
    if (index === 0) {
      this.setState({
        isReSendingInvite1: true
      })
    } else if (index === 1) {
      this.setState({
        isReSendingInvite2: true
      })
    } else if (index === 2) {
      this.setState({
        isReSendingInvite3: true
      })
    } else if (index === 3) {
      this.setState({
        isReSendingInvite4: true
      })
    }

    const data = JSON.stringify({
      aid: this.state.aid,
      to: invite.to
    })

    axios
      .post(config.apiServer + '/api/v4/familyplan/secondary/invite', data, {
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then(
        response => {
          this.callingAjax = false

          this.setState({
            isReSendingInvite1: false,
            isReSendingInvite2: false,
            isReSendingInvite3: false,
            isReSendingInvite4: false
          })

          const status = response.status
          const json = response.data
          // console.log("onReSendInviteClicked: response json: [" + JSON.stringify(json) + "]")

          if (status === 200) {
            this.setState({
              systemMessage: {
                message: "Successfully re-sent invite to " + invite.to,
                type: 'success',
                duration: 6000,
                timestamp: new Date().getTime()
              }
            })
          } else {
            console.log(response)

            // this.setState({
            //   systemMessage: {
            //     message: json.err_msg,
            //     type: 'error',
            //     duration: 6000,
            //     timestamp: new Date().getTime()
            //   }
            // })
          }
        },
        error => {
          this.callingAjax = false

          console.log(error)

          this.setState({
            isReSendingInvite1: false,
            isReSendingInvite2: false,
            isReSendingInvite3: false,
            isReSendingInvite4: false
          })

          const json = error.response.data
          let dispMsg = 'Unexpected error re-sending invite, try again later.'
          if (json.hasOwnProperty("display_msg")) {
            dispMsg = json.display_msg
          }

          // console.log("onReSendInviteClicked error response: [" + JSON.stringify(json) + "]");
          this.setState({
            systemMessage: {
              message: dispMsg,
              type: 'error',
              duration: 9000,
              timestamp: new Date().getTime()
            }
          })
        }
      )
  }

  onRemoveInviteClicked = (invite, index) => {
    console.log("onRemoveInviteClicked: invite=[" + invite.to + "]")

    if (this.callingAjax) {
      return
    }

    this.callingAjax = true

    // Add a loading animation while the removal is happening
    if (index === 0) {
      this.setState({
        isRemovingInvite1: true
      })
    } else if (index === 1) {
      this.setState({
        isRemovingInvite2: true
      })
    } else if (index === 2) {
      this.setState({
        isRemovingInvite3: true
      })
    } else if (index === 3) {
      this.setState({
        isRemovingInvite4: true
      })
    }

    const data = JSON.stringify({
      aid: this.state.aid,
      pending_invite_id: invite.id
    })

    axios
      .post(config.apiServer + '/api/v4/familyplan/secondary/invite/remove', data, {
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then(
        response => {
          this.callingAjax = false

          this.setState({
            isRemovingInvite1: false,
            isRemovingInvite2: false,
            isRemovingInvite3: false,
            isRemovingInvite4: false
          })

          const status = response.status
          const json = response.data
          // console.log("onRemoveInviteClicked: response json: [" + JSON.stringify(json) + "]")

          if (status === 200) {
            let settings = this.state.settings
            settings.pending_invites.splice(index, 1) // 2nd parameter means remove one item only

            this.setState({
              settings: settings,
              systemMessage: {
                message: "Successfully removed invite to " + invite.to,
                type: 'success',
                duration: 6000,
                timestamp: new Date().getTime()
              }
            })
          } else {
            console.log(response)

            // this.setState({
            //   systemMessage: {
            //     message: json.err_msg,
            //     type: 'error',
            //     duration: 6000,
            //     timestamp: new Date().getTime()
            //   }
            // })
          }
        },
        error => {
          this.callingAjax = false

          console.log(error)

          this.setState({
            isRemovingInvite1: false,
            isRemovingInvite2: false,
            isRemovingInvite3: false,
            isRemovingInvite4: false
          })

          const json = error.response.data
          let dispMsg = 'Unexpected error removing invite, try again later.'
          if (json.hasOwnProperty("display_msg")) {
            dispMsg = json.display_msg
          }

          // console.log("onRemoveInviteClicked error response: [" + JSON.stringify(json) + "]");
          this.setState({
            systemMessage: {
              message: dispMsg,
              type: 'error',
              duration: 9000,
              timestamp: new Date().getTime()
            }
          })
        }
      )
  }


  searchFormChangeHandler = e => {
    const target = e.target
    const value = target.value
    const name = target.name

    this.setState({
      [name]: value
    })
  }

  searchFormSubmit = e => {
    e.preventDefault()

    this.setState({
      isSearching: true,
      userSearchResults: []
    })

    axios
      .get(
        config.apiServer +
        '/api/v3/web/social/users?n=' +
        this.state.userSearchText +
        '&aid=' +
        this.state.aid +
        "&include_emails=true",
        {}
      )
      .then(
        response => {
          this.setState({
            isSearching: false
          })

          const json = response.data
          // console.log("searchFormSubmit: response json: [" + JSON.stringify(json) + "]")

          if (json.key === 'OK') {
            const resultsJson = json.results
            const resultsCount = resultsJson.length

            let resultsFriends = []

            if (resultsCount > 0) {
              // Fetch the friends and put each bit of JSON into an array
              for (let i = 0; i < resultsCount; i++) {
                resultsFriends.push(resultsJson[i])
              }
            } else {
              this.setState({
                systemMessage: {
                  message:
                    'No results found for your search',
                  type: 'error',
                  duration: 6000,
                  timestamp: new Date().getTime()
                }
              })
            }

            this.setState((state, props) => ({
              userSearchResults: resultsFriends
            }))
          } else {
            console.log(response)

            this.setState({
              systemMessage: {
                message:
                  'There was an error while searching for users. Please try again later.',
                type: 'error',
                duration: 6000,
                timestamp: new Date().getTime()
              }
            })
          }
        },
        error => {
          console.log(error)

          this.setState({
            isSearching: false
          })

          this.setState({
            systemMessage: {
              message:
                'There was an error while searching for users. Please try again later.',
              type: 'error',
              duration: 6000,
              timestamp: new Date().getTime()
            }
          })
        }
      )
  }

  nonUserInviteFormChangeHandler = e => {
    const target = e.target
    const value = target.value
    const name = target.name

    this.setState({
      [name]: value
    })
  }

  nonUserInviteFormSubmit = e => {
    e.preventDefault()

    if (this.callingAjax) {
      return
    }

    this.callingAjax = true


    this.setState({
      isSendingInvite: true
    })

    const to = this.state.nonUserInviteText

    for (var i = 0; i < this.state.settings.pending_invites.length; i++) {
      const invite = this.state.settings.pending_invites[i]
      if (invite.to === to) {
        this.setState({
          isSendingInvite: false,
          systemMessage: {
            message: "You have already sent an invite to this person",
            type: 'error',
            duration: 9000,
            timestamp: new Date().getTime()
          }
        })
        return
      }
    }

    const data = JSON.stringify({
      aid: this.state.aid,
      to: to
    })

    axios
      .post(config.apiServer + '/api/v4/familyplan/secondary/invite', data, {
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then(
        response => {
          this.callingAjax = false

          this.setState({
            isSendingInvite: false
          })

          const status = response.status
          const json = response.data
          // console.log("nonUserInviteFormSubmit: response json: [" + JSON.stringify(json) + "]")

          if (status === 200) {
            const sent = json.sent
            const type = json.type
            const id = json.id

            const invite = {
              type: type,
              to: to,
              id: id
            }

            let settings = this.state.settings
            settings.pending_invites.push(invite)

            this.setState({
              settings: settings,
              nonUserInviteText: "",
              systemMessage: {
                message: "Successfully sent invite to " + to,
                type: 'success',
                duration: 6000,
                timestamp: new Date().getTime()
              }
            })

          } else {
            console.log(response)

            // this.setState({
            //   systemMessage: {
            //     message: json.err_msg,
            //     type: 'error',
            //     duration: 6000,
            //     timestamp: new Date().getTime()
            //   }
            // })
          }
        },
        error => {
          this.callingAjax = false

          console.log(error)

          this.setState({
            isSendingInvite: false
          })

          const json = error.response.data
          let dispMsg = 'Unexpected error sending invite, try again later.'
          if (json.hasOwnProperty("display_msg")) {
            dispMsg = json.display_msg
          }

          // console.log("nonUserInviteFormSubmit error response: [" + JSON.stringify(json) + "]");
          this.setState({
            systemMessage: {
              message: dispMsg,
              type: 'error',
              duration: 9000,
              timestamp: new Date().getTime()
            }
          })
        }
      )
  }

  componentDidMount() {
    console.log("FamilyPlanSettings.js: componentDidMount")
    this.apiCheckIsPrimary()
  }

  render() {
    const {
      systemMessage
    } = this.state

    console.log("FamilyPlanSettings.js: render()")

    const location = window.location.href
    console.log("FamilyPlanSettings location: [" + location + "]")

    // Temporary fix for IE embedded browser in Cook'n Windows App.
    if (!String.prototype.endsWith) {
      String.prototype.endsWith = function(search, this_len) {
        if (this_len === undefined || this_len > this.length) {
          this_len = this.length;
        }
        return this.substring(this_len - search.length, this_len) === search;
      };
    }

    let settings = this.state.settings
    let secondaryUsers = []
    if (settings.hasOwnProperty("secondary_users")) {
      secondaryUsers = settings.secondary_users
    }
    let pendingInvites = []
    if (settings.hasOwnProperty("pending_invites")) {
      pendingInvites = settings.pending_invites
    }
    // console.log("render: pending_invites: [" + JSON.stringify(pendingInvites) + "]")

    let searchElement = ""
    if (secondaryUsers.length + pendingInvites.length < 4) {
      searchElement =
        <div>
          <h3 className="large text-center" style={{fontWeight: "bold", fontSize: "1.3em"}}>
            You can invite people who have never used Cook'n before by entering their email address or phone number:
          </h3>

          {this.NonUserInvite()}

          <br/>
          <h3 className="large text-center" style={{fontWeight: "bold", fontSize: "1.3em"}}>
            You can add existing Cook'n users by searching for their name or email:
          </h3>

          {this.UserSearch()}
        </div>
    }

    let currentSecondariesElement = ""
    if (secondaryUsers.length > 0) {
      currentSecondariesElement =
        <div className="text-center" style={{ marginTop: "50px", marginBottom: "50px" }}>
          <h3 style={{
            fontWeight: "bold",
            fontSize: "1.4em",
            textAlign: "left",
            width: "450px",
            marginLeft: "auto",
            marginRight: "auto"
          }}>
            Current Members:
          </h3>
          <ul
            style={{
              listStyleType: 'none',
              padding: '0',
              maxWidth: "450px",
              marginLeft: "auto",
              marginRight: "auto"
            }}
          >
            {secondaryUsers.map((user, index) => (
              <li key={index}>
                {this.SecondaryUser(user, index)}
              </li>
            ))}
          </ul>
        </div>
    }

    let pendingInvitesElement = ""
    if (pendingInvites.length > 0) {
      pendingInvitesElement =
        <div className="text-center" style={{ marginTop: "50px", marginBottom: "70px" }}>
          <h3 style={{
            fontWeight: "bold",
            fontSize: "1.4em",
            textAlign: "left",
            width: "450px",
            marginLeft: "auto",
            marginRight: "auto"
          }}>
            Pending Invites:
          </h3>
          <ul
            style={{
              listStyleType: 'none',
              padding: '0',
              maxWidth: "450px",
              marginLeft: "auto",
              marginRight: "auto"
            }}
          >
            {pendingInvites.map((invite, index) => (
              <li key={index}>
                {this.PendingInvite(invite, index)}
              </li>
            ))}
          </ul>
        </div>
    }

    let settingsElement = ''
    if (location.endsWith("/settings")) {

      if (this.state.isLoading) {
        settingsElement = (
          <div className="text-center">
            <h2>Family Plan</h2>
            <div style={{ padding: '20px', textAlign: 'center' }}>
              <LoadingIcon />
            </div>
          </div>
        )
      } else if (!this.state.isLoading && !this.state.isPrimary) {
        settingsElement = (
          <div className="text-center">
            <h2>Family Plan</h2>
            <h3 className="large">
              You do not currently have a Cook'n Family Plan.
              <br />
              <br />
              With a Cook'n Family Plan, you can add up to 4 people from your family and friends who have not had a paid Cook'n Membership Plan before.
              <br />
              <br />
              Click here to <a href={"https://www.dvo.com/cooking-club-family-plan.php"}>sign up for a Cook'n Family Plan</a> and get the whole family Cook'n!
            </h3>
          </div>
        )
      } else if (!this.state.isLoading && this.state.isPrimary) {
        settingsElement = (
          <div>
            <div className="text-center">
              <h2>Family Plan</h2>
              <h3 className="large">
                Your Cook'n Family Plan allows you to add up to 4 other people.
              </h3>
            </div>

            {currentSecondariesElement}

            {pendingInvitesElement}

            {searchElement}

          </div>
        )
      }
    } else {
      console.log("Invites endpoint not supported")
      settingsElement = (<h1>Endpoint Not Supported</h1>)
    }

    return (
      <MuiThemeProvider theme={config.theme}>
        <Grid container>
          <Grid item xs/>
          <Grid item xs={10}>
            {settingsElement}
          </Grid>
          <Grid item xs/>
        </Grid>
        <SystemMessageSnackbar systemMessage={systemMessage}/>
      </MuiThemeProvider>
    )
  }

  SecondaryUser(user, index) {
    let buttonText = "Remove"
    let isRemoving = false
    if (index === 0) {
      isRemoving = this.state.isRemovingEmail1
    } else if (index === 1) {
      isRemoving = this.state.isRemovingEmail2
    } else if (index === 2) {
      isRemoving = this.state.isRemovingEmail3
    } else if (index === 3) {
      isRemoving = this.state.isRemovingEmail4
    }
    if (isRemoving) {
      buttonText = (
        <LoadingIconSmall />
      )
    }

    let element = (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          height: "50px",
          width: "100%",
          marginBottom: "15px",
          borderBottom: "1px solid #aaa",
        }}
      >
        <div className={"text-center"}
             style={{
               display: "flex",
               alignItems: "center",
               justifyContent: "flex-start",
               flexGrow: "1"
             }}
        >
          <img
            className="friends-list-item__img"
            src={
              user.avatarUrl === undefined || user.avatarUrl === null || user.avatarUrl === ''
                ? config.baseUrl + '/assets/img/generic-avatar-medium.png'
                : user.avatarUrl + '=s96-c'
            }
            alt={""}
            style={{
              maxHeight: "40px",
              maxWidth: "40px",
              marginRight: "10px"
            }}
          />

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start"
            }}
          >
            <span
              style={{
                fontSize: '1.1em',
                float: "left"
              }}
            >
              {user.name}
            </span>
            <span
              style={{
                fontSize: '0.9em',
                float: "left"
              }}
            >
              {user.email}
            </span>
          </div>
        </div>
        <div style={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center"
        }}>
          <Button
            variant={"contained"}
            style={{
              maxHeight: "30px",
              minHeight: "30px",
              lineHeight: "15px",
              textTransform: "none",
              backgroundColor: "#ea4236",
              color: "white",
            }}
            onClick={() => { this.onRemoveSecondaryClicked(user, index) }}
          >
            {buttonText}
          </Button>
        </div>
      </div>
    )
    return element
  }

  UserSearch() {
    let searchButtonText = "Search"
    if (this.state.isSearching) {
      searchButtonText = (
        <LoadingIconSmall />
      )
    }

    let element = (
      <div>
        <form
          id="user-search"
          className="text-center"
          style={{marginBottom: '3em'}}
          method="post"
          onSubmit={e => {
            this.searchFormSubmit(e)
          }}
        >
          <div style={{ maxWidth: "500px", margin: "auto" }}>
          <TextField
            id="user-search-text"
            name="userSearchText"
            label="Search Existing Users by Name or Email"
            margin="dense"
            variant="outlined"
            fullWidth
            required
            onChange={this.searchFormChangeHandler}
          />
          </div>
          <p>
            <Button variant="contained" color="primary" type="submit">
              {searchButtonText}
            </Button>
          </p>
        </form>

        {this.UserSearchResults()}
      </div>
    )
    return element
  }

  UserSearchResults() {
    let element = ''

    let results = this.state.userSearchResults

    if (results && results.length > 0) {
      let resultsListItems = ''
      resultsListItems = results.map(user => (
        this.UserSearchListItem(user)
      ))
      element = <ul className="friends-list">{resultsListItems}</ul>
    }
    return ( <div>{element}</div> )
  }

  UserSearchListItem(user) {
    let buttonText = "Add"

    let addingUser = this.state.addingUser
    let isAdding = (addingUser && addingUser === user.id)
    if (isAdding) {
      buttonText = (
        <LoadingIconSmall />
      )
    }

    let imgUrl = config.baseUrl + '/assets/img/generic-avatar-medium.png';
    if (user.avatarUrl !== null && user.avatarUrl !== undefined && user.avatarUrl !== '') {
      imgUrl = user.avatarUrl + '=s96-c';
    }

    return (
      <li className="friends-list-item-wide">
        <img
          className="friends-list-item__img"
          src={imgUrl}
          alt={user.name + ' Avatar'}
        />
        <h3 className="friends-list-item__name">{user.name}</h3>
        <h3 className="friends-list-item__email">{user.email}</h3>
        <Button
          variant="contained"
          color="primary"
          type="submit"
          onClick={e => {
            this.onAddSecondaryClicked(e, user)
          }}
        >
          {buttonText}
        </Button>
      </li>
    )
  }

  PendingInvite(invite, index) {
    let reSendButtonText = "Re-send"
    let removeButtonText = "Remove"
    let isReSending = false
    let isRemoving = false
    if (index === 0) {
      isReSending = this.state.isReSendingInvite1
      isRemoving = this.state.isRemovingInvite1
    } else if (index === 1) {
      isReSending = this.state.isReSendingInvite2
      isRemoving = this.state.isRemovingInvite2
    } else if (index === 2) {
      isReSending = this.state.isReSendingInvite3
      isRemoving = this.state.isRemovingInvite3
    } else if (index === 3) {
      isReSending = this.state.isReSendingInvite4
      isRemoving = this.state.isRemovingInvite4
    }
    if (isReSending) {
      reSendButtonText = (
        <LoadingIconSmall />
      )
    }
    if (isRemoving) {
      removeButtonText = (
        <LoadingIconSmall />
      )
    }

    let element = (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          height: "50px",
          width: "100%",
          marginBottom: "15px",
          borderBottom: "1px solid #aaa",
        }}
      >
        <div className={"text-center"}
             style={{
               display: "flex",
               alignItems: "center",
               justifyContent: "flex-start",
               flexGrow: "1"
             }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start"
            }}
          >
            <span
              style={{
                fontSize: '1em',
                float: "left"
              }}
            >
              {invite.to}
            </span>
          </div>
        </div>
        <div style={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center"
        }}>
          <Button
            variant={"contained"}
            style={{
              maxHeight: "30px",
              minHeight: "30px",
              lineHeight: "15px",
              textTransform: "none",
              backgroundColor: "#51a4bd",
              color: "white",
            }}
            onClick={() => { this.onReSendInviteClicked(invite, index) }}
          >
            {reSendButtonText}
          </Button>
          <Button
            variant={"contained"}
            style={{
              maxHeight: "30px",
              minHeight: "30px",
              lineHeight: "15px",
              textTransform: "none",
              backgroundColor: "#ea4236",
              color: "white",
              marginLeft: "10px"
            }}
            onClick={() => { this.onRemoveInviteClicked(invite, index) }}
          >
            {removeButtonText}
          </Button>
        </div>
      </div>
    )
    return element
  }

  NonUserInvite() {
    let inviteButtonText = "Send Invite"
    if (this.state.isSendingInvite) {
      inviteButtonText = (
        <LoadingIconSmall />
      )
    }

    let element = (
      <div style={{maxWidth: "500px", margin: "auto"}}>
        <form
          id="non-user-invite"
          className="text-center"
          style={{marginBottom: '3em'}}
          method="post"
          onSubmit={e => {
            this.nonUserInviteFormSubmit(e)
          }}
        >
          <TextField
            id="non-user-invite-text"
            name="nonUserInviteText"
            label="Invite by Email or Phone Number"
            margin="dense"
            variant="outlined"
            fullWidth
            required
            onChange={this.nonUserInviteFormChangeHandler}
          />
          <p>
            <Button variant="contained" color="primary" type="submit">
              {inviteButtonText}
            </Button>
          </p>
        </form>
      </div>
    )
    return element
  }

}

export default withRouter(FamilyPlanSettings)



// WEBPACK FOOTER //
// ./src/Components/FamilyPlanSettings.js